let productCardMarkup = `
    {{#products}}
    <div
        class="product-item product-item--vertical 1/3--tablet 1/4--lap 1/5--desk 1/6--wide"
    >
        <div
            class="product-item__label-list wishlist-discount wishlist-discount--{{ discount }}"
        >
            <span class="product-label product-label--on-sale">Save {{ discount }}</span>
        </div>
        <a
            href="{{ link }}"
            class="product-item__image-wrapper product-item__image-wrapper--with-secondary"
        >
            <div>
                <img
                    src="{{ iu }}"
                    alt="{{ dt }}"
                    class="wishlist-item__primary-image"
                >
            </div>
        </a>
        <div class="product-item__info">
            <div class="product-item__info-inner">
                <div class="product-item__title-wrap">
                    <a
                        href="{{ link }}"
                        class="product-item__title text--strong link"
                    >
                        {{ dt }}
                    </a>
                    <!-- Swym Wishlist Plus EPI Button-->
                    <button
                        data-with-epi="true"
                        class="wishlist-button swym-button swym-add-to-wishlist-view-product product_{{ empi }} swym-icon swym-heart swym-loaded" data-swaction="addToWishlist"
                        data-product-id="{{ empi }}"
                        data-variant-id="{{ epi }}"
                        data-product-url="{{ du }}"
                        aria-label="Add to Wishlist"
                    >
                        <svg
                            focusable="false"
                            class="icon icon--heart "
                            viewBox="0 0 17 15"
                            role="presentation"
                        >
                            <path d="M15.0349331 1.40485867C14.1287273.49933787 12.9252477 0 11.6443673 0S9.16000731.49933787 8.25448651 1.40417371c-.01164437.01164436-.02328874.02328873-.03493311.03561806-.01164436-.01232933-.02260377-.02328873-.03424813-.0349331C7.2790995.49933787 6.07561989 0 4.79473949 0 3.51385908 0 2.31037947.49933787 1.40417371 1.40485867.49796794 2.31037947 0 3.51385908 0 4.79473949 0 6.07561989.4986529 7.2790995 1.40417371 8.1846203L8.2195534 15l6.8153797-6.8153797c.9055208-.9055208 1.4041737-2.10900041 1.4041737-3.38988081 0-1.28019545-.4986529-2.48436002-1.4041737-3.38988082z"></path>
                        </svg>
                        <span class="swym-tooltip swym-inject swym-tooltip-clickable">
                            <span class="swym-tooltip-text">Add to wishlist</span>
                        </span>
                    </button>
                    <!-- Swym Wishlist Plus EPI Button-->
                </div>
                <div class="product-item__price-list price-list">
                    <span class="price wishlist-item-price">{{ priceString }}</span>
                </div>
                <div class="product-item__form-type-{{ productType }} wishlist__cart-add-wrap">
                  <button
                    type="submit"
                    class="product-item__action-button button button--small button--primary add-product-variant-{{ epi }}"
                    onClick='(function(){window.Rebuy.Cart.addItem({"id":"{{ epi }}","quantity":1});return false;})();return false;'
                  >Add to cart</button>
                </div>
                <div class="wishlist__cart-add-wrap--link wishlist__cart-add-wrap--{{ productType }} wishlist__cart-add-wrap">
                  <a href="{{ link }}" class="product-item__action-button button button--small button--primary">Take another look</a>
                </div>
            </div>
        </div>
    </div>
  {{/products}}
`;

function getVariantInfo(variants) {
  try {
    let variantKeys =
        variants && variants != "[]"
          ? Object.keys(JSON.parse(variants)[0])
          : [],
      variantinfo;
    if (variantKeys.length > 0) {
      variantinfo = variantKeys[0];
      if (variantinfo == "Default Title") {
        variantinfo = "";
      }
    } else {
      variantinfo = "";
    }
    return variantinfo;
  } catch (err) {
    return variants;
  }
}

function swymCallbackFn(swat) {
  // Get all json for each product
  getEntireProducts(swat, function (fullProductDataArray) {
    // Sort by ID
    fullProductDataArray.sort((a, b) => (a.id > b.id ? 1 : -1));

    // console.log(
    //   "Array of Wishlisted Products with Entire Data",
    //   fullProductDataArray
    // );
    // console.log("...");

    goSwimming(fullProductDataArray);
  });

  function goSwimming(fullProductDataArray) {
    // gets called once Swym is ready
    const wishlistContentsContainer = document.getElementById(
      "wishlist-items-container"
    );
    _swat.fetchWrtEventTypeET(function (products) {
      // Get wishlist items
      // Sort by ID
      products.sort((a, b) => (a.empi > b.empi ? 1 : -1));
      //console.log("products: ", products);
      let formattedWishlistedProducts = products.map(function (p, index) {
        p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
        p.isInCart =
          _swat.platform.isInDeviceCart(p.epi) ||
          p.et == _swat.EventTypes.addToCart;
        p.variantinfo = p.variants ? getVariantInfo(p.variants) : "";

        if (fullProductDataArray[index].compare_at_price != null) {
          p.discount =
            Math.round(
              parseFloat(
                ((fullProductDataArray[index].compare_at_price -
                  fullProductDataArray[index].price) /
                  fullProductDataArray[index].compare_at_price) *
                  100
              )
            ) + "%";
        } else {
          p.discount = "";
        }

        p.priceString = function () {
          const amount = fullProductDataArray[index].price / 100;

          let priceLocale;
          if (window.Shopify.currency.active == "EUR") {
            priceLocale = "nl-NL";
          } else {
            priceLocale = window.Shopify.locale + "-" + window.Shopify.country;
          }

          let moneyFormat = new Intl.NumberFormat(priceLocale, {
            style: "currency",
            currency: window.Shopify.currency.active,
            currencyDisplay: "symbol"
          });
          return moneyFormat.format(amount).replace(" ", "");
        };

        p.link = p.du.replace(".com/", ".com" + window.Shopify.routes.root);

        p.type = fullProductDataArray[index].type;

        p.productType = p.type ? p.type.replace(" ", "").toLowerCase() : "none";

        p.tags = window._swat.fetch(function (r) {
          return r;
        });
        //console.log("p: ", p);
        return p;
      });

      var productCardsMarkup = SwymUtils.renderTemplateString(
        productCardMarkup,
        { products: formattedWishlistedProducts }
      );

      wishlistContentsContainer.innerHTML = productCardsMarkup;

      attachClickListeners();
    }, window._swat.EventTypes.addToWishList);
  }
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}

window.SwymCallbacks.push(swymCallbackFn);

function attachClickListeners() {
  document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
  // Dispatch the event
  document.dispatchEvent(wishlistBuiltEvent);
}

// Full product
function getEntireProducts(swat, callback) {
  var __wishlistedProducts = [];
  swat.fetch(function (products) {
    products.forEach(function (product) {
      swat.getProductDetails(
        product,
        function (fullJSON) {
          __wishlistedProducts.push(fullJSON);
          if (products.length == __wishlistedProducts.length) {
            callback(__wishlistedProducts);
          }
        },
        function (e) {
          swat.removeFromWishList(product, function (e) {
            //console.log("Removed, Unpublished product");
          });
        }
      );
    });
  });
}

const wishlistBuiltEvent = new Event("build");

// Listen for cart ready
document.addEventListener("rebuy:cart.change", function (event) {
  setTimeout(function () {
    // Listen for wishlist ready
    document.addEventListener(
      "build",
      (e) => {
        //console.log("wishlistBuiltEvent...");
        maxOrder(event);
      },
      false
    );
  }, 0);
});
